import { useState } from 'react'
import type { StepInputProps } from './StepInput'

/**
 * Pris-bracket størrelse pr. audience.
 *
 *   - unge:   100 kr-brackets (fx 1.000 – 1.100), fin granularitet matcher
 *             ung-segmentet hvor budget er stramt og 100 kr gør forskel.
 *   - aeldre: 200 kr-brackets (fx 1.000 – 1.200), bredere intervaller fordi
 *             senior-segmentet typisk ikke kender det præcise tal og bredere
 *             spænd føles mindre forpligtende at vælge.
 *
 * Bemærk: slider-step matches bracket-størrelsen så snapping og display
 * altid stemmer overens.
 */
const BRACKET = { unge: 100, aeldre: 200 } as const

function formatPrice(v: number, bracket: number): string {
  if (v >= 2000) return '2.000+'
  const lower = Math.floor(v / bracket) * bracket
  return `${lower.toLocaleString('da-DK')} – ${(lower + bracket).toLocaleString('da-DK')}`
}

export function CurrentPriceInput({ state, audience, onSubmit }: StepInputProps) {
  const bracket = BRACKET[audience]
  const [price, setPrice] = useState(state.currentPriceVal ?? 1000)
  const submit = () =>
    onSubmit({
      currentPrice: price >= 2000 ? '2.000+ kr/md' : `${formatPrice(price, bracket)} kr/md`,
      currentPriceVal: price,
    })
  const submitUnknown = () => onSubmit({ currentPrice: 'Ved ikke', currentPriceVal: null })

  return (
    <div className="input-dock">
      <div className="slider-display">
        <div className="slider-value">{formatPrice(price, bracket)}</div>
        <div className="slider-suffix">kr. om måneden</div>
      </div>
      <input
        type="range"
        className="slider-track"
        min={300}
        max={2000}
        step={bracket}
        value={price}
        onChange={(e) => setPrice(parseInt(e.target.value, 10))}
      />
      <div className="slider-bounds">
        <span>300 kr</span>
        <span>2.000+ kr</span>
      </div>
      <button className="btn-send full" onClick={submit}>Videre</button>
      {/* "Jeg er ikke sikker" beholdes kun for unge-flowet — feedback fra aeldre-
          target var at det føltes som en udvej der underminerede svaret, og at
          aeldre-segmentet typisk har et godt overslag over hvad de betaler. */}
      {audience === 'unge' && (
        <button onClick={submitUnknown} className="slider-link">Jeg er ikke sikker</button>
      )}
    </div>
  )
}
